import './component.scss'
import 'Components/nurikae_site/pages/company/show/pc/partials/clamp_text/component'
import './images/yet.svg'
import './images/done.svg'

import { Application, Controller } from 'stimulus'

const maxTextLines = 3

const app = Application.start()

// 参考になったボタン機能
app.register(
  'site-reviews-sp-helpful',
  class extends Controller {
    static targets = ["helpfulSection", "helpfulIcon", "helpfulText"]
    static values = { reviewId: String, helpfulCount: Number }

    connect() {
      this.isHelpful = this.getHelpfulState()
      this.currentCount = this.helpfulCountValue
      this.updateUI()
      
      // linkのクリックイベントを監視
      this.helpfulSectionTarget.addEventListener('click', this.handleClick.bind(this))
    }

    async handleClick(event) {
      event.preventDefault()

      if (this.isHelpful) {
        // 既に押されている場合はリクエストをキャンセル
        return false
      };

      // UIを先に更新
      this.isHelpful = true
      this.saveHelpfulState()
      this.currentCount += 1
      this.updateUI()

      const url = `/introduce_reviews/${this.reviewIdValue}/increment_helpful_count`

      try {
        await this.sendRequest(url, 'PATCH')
      } catch (error) {
        console.error('Failed to update helpful count:', error)
        // エラーの場合はUIを元に戻す
        this.isHelpful = false
        this.removeHelpfulState()
        this.currentCount -= 1
        this.updateUI();
      }
    };

    async sendRequest(url) {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
      return response
    }

    updateUI() {
      const iconElement = this.helpfulIconTarget
      const textElement = this.helpfulTextTarget
      const sectionElement = this.helpfulSectionTarget

      // テキストコンテンツを更新
      this.updateTextContent(textElement)

      if (this.isHelpful) {
        // アクティブ状態（押された状態）
        sectionElement.classList.add('company-show-review-card__helpful--active')
        iconElement.classList.remove('company-show-review-card__helpful-icon--yet')
        iconElement.classList.add('company-show-review-card__helpful-icon--done')
      } else {
        // 非アクティブ状態（押されていない状態）
        sectionElement.classList.remove('company-show-review-card__helpful--active')
        iconElement.classList.remove('company-show-review-card__helpful-icon--done')
        iconElement.classList.add('company-show-review-card__helpful-icon--yet')
      }
    }

    updateTextContent(textElement) {
      if (this.currentCount === 0) {
        textElement.textContent = '参考になった'
      } else {
        textElement.textContent = `参考になった ${this.currentCount}人`
      }
    }

    getHelpfulState() {
      const storageKey = `nurikae_helpful_review_${this.reviewIdValue}`
      return localStorage.getItem(storageKey) === 'true'
    }

    saveHelpfulState() {
      const storageKey = `nurikae_helpful_review_${this.reviewIdValue}`
      localStorage.setItem(storageKey, 'true')
    }

    removeHelpfulState() {
      const storageKey = `nurikae_helpful_review_${this.reviewIdValue}`
      localStorage.removeItem(storageKey)
    }
  }
)

// レビューカード展開/折りたたみ機能
app.register(
  'review-card-toggle',
  class extends Controller {
    static targets = ["showMoreButton", "reviewRating", "reviewerInfo", "closeButton"]

    connect() {
      // 初期状態を設定
      this.showCollapsedState()
      this.bodyTextElement = this.element.querySelector('.company-show-clamp-line__body-text')
    }

    toggleExpand() {
      this.showExpandedState()
      // テキストの省略を解除
      if (this.bodyTextElement) {
        this.bodyTextElement.style.webkitLineClamp = 'none'
        this.bodyTextElement.style.lineClamp = 'none'
      }
    }

    toggleCollapse() {
      this.showCollapsedState()
      // テキストの省略を復元
      if (this.bodyTextElement) {
        this.bodyTextElement.style.webkitLineClamp = maxTextLines
        this.bodyTextElement.style.lineClamp = maxTextLines
      }
    }

    showExpandedState() {
      // 「すべて見る」ボタンを非表示
      this.showMoreButtonTarget.classList.add('company-show-review-card__hidden')
      // review-ratingとreviewer-infoを表示
      this.reviewRatingTarget.classList.remove('company-show-review-card__hidden')
      this.reviewerInfoTarget.classList.remove('company-show-review-card__hidden')
      // 「閉じる」ボタンを表示
      this.closeButtonTarget.classList.remove('company-show-review-card__hidden')
    }

    showCollapsedState() {
      // 「すべて見る」ボタンを表示
      this.showMoreButtonTarget.classList.remove('company-show-review-card__hidden')
      // review-ratingとreviewer-infoを非表示
      this.reviewRatingTarget.classList.add('company-show-review-card__hidden')
      this.reviewerInfoTarget.classList.add('company-show-review-card__hidden')
      // 「閉じる」ボタンを非表示
      this.closeButtonTarget.classList.add('company-show-review-card__hidden')
    }
  }
)
